const SDK_VERSION = '8.32.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
